<template>
    <!--新闻动态-->
    <div class="newviewsbox" v-loading="loading">
        <headerbox :focus="3"></headerbox>
        <div class="newsimgbox">
        </div>
        <div class="newslist">
            <div class="newsunit" v-for="(item,index) in listdata ">
                <div class="newsunitleft">
                    {{item.time.year}}年{{item.time.month}}月
                </div>
                <div class="newsunitright">
                    <p>  {{item.title}}</p>
                    <div class="time">{{item.times}}</div>
                    <span class="contents">{{item.content}}
                    </span>
                    <div class="butos" @click="jumpdetails(item.id)">
                        查看详情
                    </div>
                </div>
            </div>

        </div>
        <div class="pagebox">
            <el-pagination
                    @current-change="handleCurrentChange"
                    background
                    :current-page.sync="page_now"
                    :page-size="currentPage"
                    layout="prev, pager, next,jumper"
                    :total="page_total"
            ></el-pagination>
        </div>
        <div style="width: 100%;height: 0.6rem">

        </div>

        <botbox></botbox>

    </div>

</template>

<script>
    import {auth, anth} from '../request/api';
    import headerbox from "../components/boxtop";
    import botbox from "../components/botts";
    import news from "../../public/statics/newsdata"


    export default {
        name: "newviews",
        components: {
            headerbox,botbox
        },
        data() {
            return {
                loading:true,
                listdata:[],
                listdataall:[],
                //分页信息
                pageall: 0, //总条数
                pagesize: 0, //每页多少条
                page_now: 1, //当前页,
                page_total: 0, //总页数
                currentPage: 1, //初始页
                //搜索
            }
        },
        beforeRouteEnter:(to,from,next)=>{
            next(vm=>{
                if(from.fullPath.includes('newviewsdetail?id')||from.fullPath.includes('news_view?')){

                }else{
                  vm.page_now=1;
                  vm.getnew(1);
                }
            })
        },
        created(){
            this.listdataall=news.newslist;
        },
        mounted() {
            setTimeout(()=>{
                this.loading=false;
            },300);
            this.getnew(this.page_now);
        },
        methods: {
            jumpdetails(e){
                window.localStorage.setItem('dtpage',e);
                if (e > 9) {
                  this.$router.push({
                    path: '/news_view',
                    query: {
                      url: this.listdataall[this.listdataall.length - e - 1].url
                    }
                  })
                  return false
                }
                this.$router.push({
                    path:"/newviewsdetail",
                    query:{
                        id:e
                    }
                })
            },
            handleCurrentChange(val){
                this.getnew(val);
            },
            getnew(page){
                this.page_now=Number(page);
                this.pagesize=2;
                this.page_total=Math.ceil(this.listdataall.length/this.pagesize);
                // this.listdata=
                let left = this.page_now * this.pagesize - this.pagesize;
                let right = this.page_now*this.pagesize;
                this.listdata= this.listdataall.slice(left, right);//取出一页数据
            },
        },
    }
</script>

<style scoped lang='scss'>
    .newviewsbox {
        width: 100%;
        height: auto;
        background: #fff;

        .newsimgbox {
            width: 24rem;
            height: 3.75rem;
            /*background: #2B2C44;*/
            position: fixed;
            top: 0;
            background-image: url("../../public/statics/img/img_new.jpg");
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
        }

        .newslist {
            width: 18rem;
            margin: 3.7rem auto 0;
            .newsunit {
                height: 2rem;
                display: flex;
                justify-content: space-between;
                background: #ffffff;
                border-bottom: 1px solid #eeeeee;
                padding: 0.5rem 0 0.2rem;

                .newsunitleft {
                    display: flex;
                    align-items: center;
                    width: 4rem;
                    height: auto;
                    font-family: "PingFang SC";
                    font-size: 0.3rem;
                    padding-left: 2rem;
                    box-sizing: border-box;
                    color: #666666;
                }

                .newsunitright {
                    width: 14rem;
                    display: flex;
                    justify-content: space-between;
                    flex-direction: column;
                    align-items: flex-start;
                    padding-left: 1rem;
                    padding-right: 1rem;
                    box-sizing: border-box;

                    p {
                        width: 100%;

                        font-weight: bold;
                        font-family: "PingFang SC";
                        font-size: 18px;
                        line-height: 24px;
                        text-align: left;
                    }

                    .time {
                        width: 100%;
                        text-align: left;
                        font-size: 14px;
                        /*color: #b9b9b9;*/
                        color: #bcbdc1;
                        font-family: "PingFang SC";
                        /*color: #999;*/
                    }
                    .contents{
                        max-height: 60px;
                        word-break: break-all;
                        text-overflow: ellipsis;
                        display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
                        -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
                        -webkit-line-clamp: 2; /** 显示的行数 **/
                        overflow: hidden;  /** 隐藏超出的内容 **/
                    }
                    span {
                        width: 100%;
                        font-size: 14px;
                        line-height: 20px;
                        letter-spacing: 1px;
                        font-family: "PingFang SC";
                        text-align: left;
                        color: #999;
                    }

                    .butos {
                        color: #447dfd;
                        font-family: "PingFang SC";
                        font-size: 14px;
                        line-height: 40px;
                        cursor: pointer;
                    }

                    .butos:active {
                        opacity: 0.85;
                    }
                }
            }
            .newsunit:last-child{
                border: none;
            }
        }

        .pagebox {
            width: 18rem;
            margin: 20px auto ;
            display: flex;
            justify-content: flex-end;
        }
    }
</style>
<style lang="scss">
    ::-webkit-scrollbar {
        width: 0;
    }
    .newviewsbox {
        overflow-x:hidden;
        .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
            border-radius: 50%;

        }

        .el-pager {
            .number {
                background: #fff !important;
            }

            .more {
                background: #fff !important;
            }
        }

        .el-pagination.is-background .el-pager li:not(.disabled).active {
            color: #447dfd !important;
            font-weight: bolder!important;
            font-size: 18px!important;
            line-height: 24px!important;

        }

        /*.el-pagination.is-background .el-pager li:not(.disabled):hover{
            color:#139f9a!important
        }*/
    }

</style>
